<template>
  <v-app-bar
    id="app-bar"
    app
    clipped-left
    height="65px"
  >
    <v-img
      id="iconImg"
      :src="imagem"
      contain
    />

    <v-btn
      id="barMenu"
      class="mr-3"
      elevation="1"
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon v-if="value">
        mdi-view-quilt
      </v-icon>

      <v-icon v-else>
        mdi-dots-vertical
      </v-icon>
    </v-btn>

    <v-spacer />

    <div class="mx-3" />

    <v-row id="inicio">
      <v-btn
        id="btnInicio"
        to="/"
        class="ml-2"
        min-width="10"
        text
      >
        <router-link
          to="/dashboard"
          :style="styleObject"
        >
          Início
        </router-link>
      </v-btn>

      <v-btn
        id="btnEditarPerfil"
        to="/"
        class="ml-2"
        min-width="10"
        text
      >
        <router-link
          to="/editar-perfil"
          :style="styleObject"
        >
          Editar Perfil
        </router-link>
      </v-btn>

      <!-- <dashboard-core-settings id="btnConfig" /> -->

      <dashboard-core-cart
        id="btnCart"
        :cart="cart"
      />
    </v-row>

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <!-- <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template> -->

      <v-list
        :tile="false"
        flat
        nav
      >
        <template v-for="(p, i) in profile">
          <v-divider
            v-if="p.divider"
            :key="`divider-${i}`"
            class="mb-2 mt-2"
          />

          <app-bar-item
            v-else
            :key="`item-${i}`"
            :to="p.to"
          >
            <v-list-item-title v-text="p.title" />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>

    <v-btn
      id="sair"
      class="ml-2"
      min-width="10"
      text
      :color="corPrimaria"
      @click="logout()"
    >
      Sair
    </v-btn>
  </v-app-bar>
</template>

<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  import Carrinho from '../../../../services/carrinhoservice'
  import Login from '../../../../services/login'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      // DashboardCoreSettings: () => import('../core/Settings'),
      DashboardCoreCart: () => import('../core/Cart'),

      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      notifications: [
        'Mike John Responded to your email',
        'You have 5 new tasks',
        'You\'re now friends with Andrew',
        'Another Notification',
        'Another one',
      ],
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      imagem: localStorage.imagem,
      cart: 0,
      profile: [
        {
          title: 'Perfil',
          to: '/editar-perfil',
        },
        { title: 'Configurações' },
        { divider: true },
        {
          title: 'Log out',
          to: '/',
        },
      ],
    }),

    computed: {
      ...mapState(['drawer']),
      computedOnLine () {
        if (navigator.onLine) {
          return true
        } else {
          return false
        }
      },
    },

    created () {
      this.onUpdateCart()
    },

    mounted () {
      this.carregaCarrinho()
      if (localStorage.countDownViewMenu <= 15) {
        this.setDrawer(!this.drawer)
        localStorage.countDownViewMenu++
      }
    },

    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),

      onUpdateCart () {
        this.$root.$on('update-cart', (cart) => {
          this.updateCart(cart)
        })
      },

      updateCart (cart) {
        this.cart = cart
      },

      logout () {
        Login.logout(localStorage.username, localStorage.tokencontrato).then(resposta => {
          localStorage.removeItem('username')
          localStorage.removeItem('email')
          localStorage.removeItem('nome')

          this.$router.push('/login')
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      carregaCarrinho () {
        Carrinho.show(localStorage.username, localStorage.tokencontrato).then(resposta => {
          this.itensCarrinho = resposta.data.itensCarrinho
          if (this.itensCarrinho) {
            this.produtoNomes = this.itensCarrinho
            this.cart = this.produtoNomes.length
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
          }
        })
      },
    },
  }
</script>

<style lang="sass">
  #app-bar
    background-color: white

  #iconImg
    height: 4.6em
    width: 9em
    position: absolute

  #barMenu
    margin-left: 15em

  #inicio
    text-align: center

  #btnInicio
    margin-top: 0.5em

  #btnEditarPerfil
    margin-top: 0.5em

  #btnConfig
    margin-top: 0.4em

  #btnCart
    margin-top: -0.3em

</style>
